import deepEqual from "deep-equal";
import { tidyUpSequenceData } from "@teselagen/sequence-utils";
import uuid from "shortid";
import createAction from "../utils/createMetaAction";
import features from "./features";
import parts from "./parts";
import name from "./name";
import description from "./description";
import primers from "./primers";
import sequence from "./sequence";
import circular from "./circular";
import materiallyAvailable from "./materiallyAvailable";
import translations from "./translations";
import combineReducersDontIgnoreKeys from "../../utils/combineReducersDontIgnoreKeys";
import { createReducer } from "redux-act";
export * from "./primers";
export * from "./features";
export * from "./parts";
export * from "./name";
export * from "./description";
export * from "./circular";
export * from "./materiallyAvailable";
export * from "./translations";
const _updateSequenceData = createAction("SEQUENCE_DATA_UPDATE");
export const updateSequenceData = function(seqData, ...rest) {
  return _updateSequenceData(
    tidyUpSequenceData(seqData, { annotationsAsObjects: true }),
    ...rest
  );
};
const coreReducer = combineReducersDontIgnoreKeys({
  primers,
  features,
  parts,
  sequence,
  translations,
  size: (state = {}) => state,
  circular,
  materiallyAvailable,
  name,
  description,
  fromFileUpload: createReducer({}, false)
});
export default function(state, action) {
  let stateToPass = state;
  if (action.type === "SEQUENCE_DATA_UPDATE") {
    stateToPass = action.payload;
  }
  const newState = coreReducer(stateToPass, action);
  if (deepEqual(newState, state)) {
    return state;
  } else {
    return {
      // ...cloneDeep(newState),
      ...newState,
      stateTrackingId: newState.stateTrackingId ? uuid() : "initialLoadId"
    };
  }
}
